import { DashboardBackgroundScripts } from '@atlassian/jira-background-scripts-layout/src/ui/dashboard/index.tsx';
import { createLayout, type Layout } from '@atlassian/jira-route-layout';

export const dashboardBackgroundScriptsLayout: Layout = createLayout({
	globalComponents: [DashboardBackgroundScripts],
});

export { DashboardBackgroundScripts } from '@atlassian/jira-background-scripts-layout/src/ui/dashboard/index.tsx';
